<div class="alert alert-success center-block text-left animated fadeIn fast">
    <img class="file-success-icon" src="assets/images/requests/icn-check.png" alt="OK"/>
    <span class="primary">{{ message }}</span>
</div>